module.exports = __webpack_public_path__ + "static/media/oil-4369051_1280.cd3afbca.jpg";